import {
  black2,
  black3,
  black4,
} from '../../../../assets/shared-styles/general';

const styles = {
  headerUsers: {
    fontSize: '12px',
    fontWeight: '600',
    color: black2,
    lineHeight: '1.4',
  },
  headerEmails: {
    marginTop: '20px',
    marginBottom: '8px',
    fontSize: '12px',
    fontWeight: '600',
    color: black2,
    lineHeight: '1.4',
  },
  domainsContainer: {
    marginBottom: '20px',
  },
  allEmailDocChoice: {
    marginTop: '10px',
    fontSize: '15px',
    lineHeight: '1.4',
    color: black2,
    display: 'flex',
    alignItems: 'flex-start',
  },
  selectEmailDocChoice: {
    marginTop: '10px',
    marginBottom: '15px',
    fontSize: '15px',
    lineHeight: '1.4',
    color: black2,
    display: 'flex',
    alignItems: 'flex-start',
  },
  multipleValuesEmpty: {
    color: black4,
    fontSize: '15px',
  },
  multipleValuesContainer: {
    display: 'flex',
    alignItems: 'center',
    marginTop: '12px',
  },
  multipleValues: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    flex: 1,
    minHeight: '30px',
    marginLeft: '8px',
  },
  domainInfo: {
    maxWidth: '500px',
    lineHeight: '1.4',
    fontSize: '13px',
    color: black3,
    marginBottom: '10px',
  },
  hideUserMultiSelect: { display: 'none' },
  showUserMultiSelect: { display: 'inline-block' },
};
export default styles;
